const init = () => {
	if (!window.ocm?.sprites) {
		return;
	}

	const benefitsCarelabelsUrl = `${window.ocm.config.resourcesHostname}/_ui/project/sprites/${window.ocm.sprites["benefits-carelabels"]}`;
	const iconsUrl = `${window.ocm.config.resourcesHostname}/_ui/project/sprites/${window.ocm.sprites.icons}`;
	const logoIconUrl = `${window.ocm.config.resourcesHostname}/_ui/project/sprites/${window.ocm.sprites.logos}`;
	const categoriesIconUrl = `${window.ocm.config.resourcesHostname}/_ui/project/sprites/${window.ocm.sprites.categories}`;

	getSpriteAndInject(benefitsCarelabelsUrl);
	getSpriteAndInject(iconsUrl);
	getSpriteAndInject(logoIconUrl);
	getSpriteAndInject(categoriesIconUrl);
};

async function getSpriteAndInject(spriteUrl) {
	try {
		const response = await fetch(spriteUrl, { headers: { Accept: "image/svg+xml" } });
		if (!response.ok) throw new Error(`Failed to fetch sprite. ${response.statusText}`);

		const data = await response.text();
		document.body.insertAdjacentHTML("afterbegin", data);
	} catch (error) {
		console.error("sprite fetch:", error);
	}
}

export { init };
